import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://klsrthmhyfaewayilfzd.supabase.co'
const supabaseKey = 'sb_publishable_KPp23ZRsyqYdyfZ49GkZbw_MhS9To7r'

export const supabase = createClient(supabaseUrl, supabaseKey)

/*
==================================================
SUPABASE SQL SCHEMA - Εκτέλεσε στο Supabase SQL Editor
==================================================

-- Πίνακας χρηστών (επέκταση του auth.users)
create table public.profiles (
  id uuid references auth.users on delete cascade primary key,
  email text,
  full_name text,
  points integer default 0,
  total_scans integer default 0,
  created_at timestamp with time zone default now()
);

-- Πίνακας κάδων ανακύκλωσης
create table public.bins (
  id uuid default gen_random_uuid() primary key,
  name text not null,
  address text,
  type text not null, -- 'paper','plastic','glass','electronics','clothes','mixed'
  lat double precision,
  lng double precision,
  qr_code text unique not null,
  created_at timestamp with time zone default now()
);

-- Πίνακας σκαναρισμάτων
create table public.scans (
  id uuid default gen_random_uuid() primary key,
  user_id uuid references public.profiles(id) on delete cascade,
  bin_id uuid references public.bins(id),
  points_earned integer default 20,
  spot_check_required boolean default false,
  spot_check_passed boolean,
  scanned_at timestamp with time zone default now()
);

-- Πίνακας rewards
create table public.rewards (
  id uuid default gen_random_uuid() primary key,
  name text not null,
  partner text not null,
  points_cost integer not null,
  description text,
  active boolean default true
);

-- Πίνακας εξαργυρώσεων
create table public.redemptions (
  id uuid default gen_random_uuid() primary key,
  user_id uuid references public.profiles(id) on delete cascade,
  reward_id uuid references public.rewards(id),
  points_spent integer,
  redeemed_at timestamp with time zone default now()
);

-- Αυτόματη δημιουργία profile μετά την εγγραφή
create or replace function public.handle_new_user()
returns trigger as $$
begin
  insert into public.profiles (id, email, full_name)
  values (new.id, new.email, new.raw_user_meta_data->>'full_name');
  return new;
end;
$$ language plpgsql security definer;

create trigger on_auth_user_created
  after insert on auth.users
  for each row execute procedure public.handle_new_user();

-- RLS Policies
alter table public.profiles enable row level security;
alter table public.scans enable row level security;
alter table public.redemptions enable row level security;
alter table public.bins enable row level security;
alter table public.rewards enable row level security;

create policy "Users see own profile" on public.profiles for select using (auth.uid() = id);
create policy "Users update own profile" on public.profiles for update using (auth.uid() = id);
create policy "Users see own scans" on public.scans for select using (auth.uid() = user_id);
create policy "Users insert own scans" on public.scans for insert with check (auth.uid() = user_id);
create policy "Users update own scans" on public.scans for update using (auth.uid() = user_id);
create policy "Users see own redemptions" on public.redemptions for select using (auth.uid() = user_id);
create policy "Users insert own redemptions" on public.redemptions for insert with check (auth.uid() = user_id);
create policy "Anyone sees bins" on public.bins for select using (true);
create policy "Anyone sees rewards" on public.rewards for select using (true);

-- Demo data - Κάδοι
insert into public.bins (name, address, type, lat, lng, qr_code) values
('Κάδος Χαρτιού - Πλατεία Αριστοτέλους', 'Πλατεία Αριστοτέλους, Θεσσαλονίκη', 'paper', 40.6401, 22.9444, 'BIN-PAPER-001'),
('Κάδος Πλαστικού - Πάρκο ΧΑΝΘ', 'Λεωφ. Νίκης, Θεσσαλονίκη', 'plastic', 40.6263, 22.9480, 'BIN-PLASTIC-001'),
('ΚΔΑΥ Κέντρου', 'Εγνατία 154, Θεσσαλονίκη', 'mixed', 40.6380, 22.9356, 'BIN-MIXED-001'),
('Κάδος Γυαλιού - Δικαστήρια', 'Λεωφ. Γεωργικής Σχολής, Θεσσαλονίκη', 'glass', 40.6211, 22.9785, 'BIN-GLASS-001'),
('Κάδος Ηλεκτρονικών - Δήμος', 'Βασ. Γεωργίου Α 1, Θεσσαλονίκη', 'electronics', 40.6327, 22.9394, 'BIN-ELEC-001');

-- Demo data - Rewards
insert into public.rewards (name, partner, points_cost, description) values
('Έκπτωση 10% στην επόμενη αγορά', 'AB Βασιλόπουλος', 100, 'Ισχύει για αγορές άνω των 20€'),
('Δωρεάν καφές', 'Coffee Island', 150, 'Οποιοδήποτε ρόφημα μέχρι medium'),
('Έκπτωση 5€ στα δημοτικά τέλη', 'Δήμος Θεσσαλονίκης', 200, 'Έκπτωση στον επόμενο λογαριασμό'),
('Δωρεά στο WWF Ελλάς', 'WWF Ελλάς', 50, 'Υποστήριξη περιβαλλοντικής δράσης'),
('Δωρεάν είσοδος στο Μουσείο', 'Αρχαιολογικό Μουσείο Θεσσαλονίκης', 80, 'Ισχύει για ένα άτομο');

==================================================
*/
